/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { FileTypes } from '../models/FileTypes';
import type { FireCrawlParsePayload } from '../models/FireCrawlParsePayload';
import type { FireCrawlWebhookPayload } from '../models/FireCrawlWebhookPayload';
import type { PublicParsePayload } from '../models/PublicParsePayload';
import type { ResultsSpiderKnowledgeResponse } from '../models/ResultsSpiderKnowledgeResponse';
import type { TasksDetails } from '../models/TasksDetails';
import type { TasksResponse } from '../models/TasksResponse';
import type { TaskStatus } from '../models/TaskStatus';
import type { TaskStatusResponse } from '../models/TaskStatusResponse';
import type { TreeResultSpiderResponse } from '../models/TreeResultSpiderResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SpiderService {
  /**
   * Public Parse
   * @param requestBody
   * @returns TasksResponse Successful Response
   * @throws ApiError
   */
  public static publicParseScraperApiV1SpiderPublicParsePost(
    requestBody: PublicParsePayload,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<TasksResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scraper/api/v1/spider/public/parse/',
      body: requestBody,
      mediaType: 'application/json',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Firecrawl Parse
   * @param requestBody
   * @returns TasksResponse Successful Response
   * @throws ApiError
   */
  public static firecrawlParseScraperApiV1SpiderFirecrawlParsePost(
    requestBody: FireCrawlParsePayload,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<TasksResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scraper/api/v1/spider/firecrawl/parse/',
      body: requestBody,
      mediaType: 'application/json',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Firecrawl Webhook
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static firecrawlWebhookScraperApiV1SpiderFirecrawlWebhookPost(
    requestBody: FireCrawlWebhookPayload,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scraper/api/v1/spider/firecrawl/webhook/',
      body: requestBody,
      mediaType: 'application/json',
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Cancel Task
   * @param taskId
   * @returns void
   * @throws ApiError
   */
  public static cancelTaskScraperApiV1SpiderTasksTaskIdCancelDelete(
    taskId: string,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/scraper/api/v1/spider/tasks/{task_id}/cancel/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Task Status
   * @param taskId
   * @returns TaskStatusResponse Successful Response
   * @throws ApiError
   */
  public static getTaskStatusScraperApiV1SpiderTasksTaskIdStatusGet(
    taskId: string,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<TaskStatusResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/{task_id}/status/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Retry Task
   * Endpoint to retry a failed Celery task.
   * @param taskId
   * @returns TaskStatusResponse Successful Response
   * @throws ApiError
   */
  public static retryTaskScraperApiV1SpiderTasksTaskIdRetryPost(
    taskId: string,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<TaskStatusResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/scraper/api/v1/spider/tasks/{task_id}/retry/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Tasks
   * @param page
   * @param limit
   * @param url Search tasks by URL
   * @param campaignName Search tasks by campaign name
   * @param status Filter tasks by status
   * @returns TasksDetails Successful Response
   * @throws ApiError
   */
  public static getTasksScraperApiV1SpiderTasksGet(
    xAiAgentOrganizationContext: string,
    page: number = 1,
    limit: number = 10,
    url?: string | null,
    campaignName?: string | null,
    status?: TaskStatus | null
  ): CancelablePromise<TasksDetails> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/',
      query: {
        page: page,
        limit: limit,
        url: url,
        campaign_name: campaignName,
        status: status,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Export Tasks
   * @param taskIds
   * @returns TasksDetails Successful Response
   * @throws ApiError
   */
  public static exportTasksScraperApiV1SpiderTasksExportGet(
    xAiAgentOrganizationContext: string,
    taskIds: Array<string>,
    url?: string | null,
    campaignName?: string | null
  ): CancelablePromise<TasksDetails> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/export',
      query: {
        task_ids: taskIds,
        url: url,
        campaign_name: campaignName,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Parsed Content
   * @param taskId
   * @param page
   * @param limit
   * @returns ResultsSpiderKnowledgeResponse Successful Response
   * @throws ApiError
   */
  public static getParsedContentScraperApiV1SpiderTasksTaskIdResultGet(
    taskId: string,
    xAiAgentOrganizationContext: string,
    page: number = 1,
    limit: number = 50
  ): CancelablePromise<ResultsSpiderKnowledgeResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/{task_id}/result/',
      path: {
        task_id: taskId,
      },
      query: {
        page: page,
        limit: limit,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Download Parsed Data
   * @param taskId
   * @param fileType Type of file to download
   * @returns any Download parsed data as a ZIP file
   * @throws ApiError
   */
  public static downloadParsedDataScraperApiV1SpiderTasksTaskIdResultDownloadGet(
    taskId: string,
    xAiAgentOrganizationContext: string,
    fileType: FileTypes = FileTypes.ZIP
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/{task_id}/result/download/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      query: {
        file_type: fileType,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Result Tree
   * @param taskId
   * @returns TreeResultSpiderResponse Successful Response
   * @throws ApiError
   */
  public static getResultTreeScraperApiV1SpiderTasksTaskIdResultTreeGet(
    taskId: string,
    xAiAgentOrganizationContext: string
  ): CancelablePromise<TreeResultSpiderResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/scraper/api/v1/spider/tasks/{task_id}/result/tree/',
      path: {
        task_id: taskId,
      },
      headers: {
        'x-ai-agent-organization-context': xAiAgentOrganizationContext,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
